import * as React from 'react'
import { captureEvent } from '@doordash/lib-monitoring'

import { ErrorPage } from './error-page'

type ErrorProps = {
  children: React.ReactNode
}

type ErrorState = {
  error: any
  errorInfo: any
}

class ErrorBoundary extends React.Component<ErrorProps, ErrorState> {
  constructor(props) {
    super(props)
    this.state = { error: null, errorInfo: null }
  }
  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { error }
  }

  public componentDidCatch(error, errorInfo) {
    // Log error to Sentry
    captureEvent({
      message: 'Dasher Webview Error Boundary',
      extra: { error },
    })
  }

  public render() {
    const { children } = this.props
    const { error } = this.state

    if (error) {
      return <ErrorPage />
    }

    return children
  }
}

export default ErrorBoundary
